import moment from 'moment';
import Textarea from '../Textarea';
import PollingFooter from './PollingFooter';
import PollingInputChoiceList from './PollingInputChoiceList';
import { IconClose, PollingTextBox, PollingContainer } from './styled';
import { PollingParams } from '../types';

interface PollingProps {
  content?: string;
  polling?: PollingParams;
  onChangeContent: any;
  onChangePolling: (data: any) => any;
  onClosePolling: any;
  isExpand: boolean;
}

function Polling({
  content,
  onChangeContent,
  polling,
  onChangePolling,
  onClosePolling,
  isExpand,
}: PollingProps) {
  const handleChangePolling = (val) => {
    const data = {
      ...polling,
      ...val,
    };

    onChangePolling(data);
  };

  const setTimestampPolling = (duration) => {
    const durationConvert = {
      Days: 24 * 60 * 60,
      Hours: 60 * 60,
      Mins: 60,
    };

    const totalTime = Object.entries(duration).reduce(
      // @ts-ignore
      (dur, [key, val]) => dur + parseInt(val, 10) * durationConvert[key],
      0,
    );
    // @ts-ignore
    const timeStampTotal = moment(moment().unix()) + totalTime;

    return timeStampTotal;
  };

  const handleChangePollingDuration = ({ data, isUnlimited }) => {
    const newDuration = {
      ...polling.duration,
      ...data,
    };
    const pollingEnd = isUnlimited ? 0 : setTimestampPolling(newDuration);

    onChangePolling({
      duration: newDuration,
      polling_end: pollingEnd,
    });
  };

  const handleClosePolling = () => {
    onClosePolling();
  };

  return (
    <>
      <PollingTextBox>
        <Textarea
          placeholder="Ask a question..."
          autoSize={{ minRows: 4 }}
          value={content}
          onChange={onChangeContent}
          isExpand={isExpand}
        />
      </PollingTextBox>
      <PollingContainer>
        <IconClose onClick={handleClosePolling} />
        <PollingInputChoiceList onChangeList={handleChangePolling} />
        <PollingFooter
          onPin={handleChangePolling}
          onChangeDuration={handleChangePollingDuration}
          isPinned={polling.polling_pin}
          duration={polling.duration}
        />
      </PollingContainer>
    </>
  );
}

export default Polling;
